import { motion } from "framer-motion";
import { useAdmin } from "@/context/AdminContext";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { socials } = useAdmin();
  const { t } = useLang();
  return (
    <footer className="relative z-10 overflow-hidden border-t border-white/10 pt-20" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col gap-10 pb-16 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.25em] text-white/40">{t.footer.agency}</p>
            <p className="text-lg text-white/70">{t.footer.reach}</p>
          </div>
          <div className="flex gap-8">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group text-sm font-medium text-white/60 hover:text-white transition-colors"
                data-testid={`social-${s.label.toLowerCase()}`}
              >
                {s.label}
                <span className="ml-1 inline-block transition-transform group-hover:translate-x-0.5">↗</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="font-anton pointer-events-none select-none text-center text-[22vw] leading-[0.8] tracking-tightest text-white pb-[2vw]"
      >
        ONYQX
      </motion.h2>

      <div className="relative z-10 border-t border-white/10 py-6">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 text-xs text-white/40 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} Onyqx. {t.footer.rights}</span>
          <span>{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
};
